import React, { Component } from "react";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import { Typography, Box, IconButton, Menu, MenuItem } from "@mui/material";
import { MdMoreVert, MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { TbMoodSad } from "react-icons/tb";
import Loader from "../../common/Loader";
import PageSkeletonCustomers from "../../common/skeletons/PageSkeletonCustomers";
import CreatePriceStr from '../../common/common/CreatePriceStr';

import axios from "axios";
import { AiOutlineSafety } from "react-icons/ai";
const paths = require('../../../paths.json');

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#fff',
        color: '#222222',
        fontSize: '16px',
        fontWeight: '600',
        paddingTop: '20px',
        borderRadius: '8px',
        paddingBottom: '20px',
        borderBottom: 'none',
        textAlign: 'left',
    },
    [`&.${tableCellClasses.body}`]: {
        backgroundColor: 'var(--rebranding-content-background-color)',
        fontSize: '14px',
        color: '#222222',
        borderBottom: 'none',
        shading: 'none',
        fontWeight: '500',
        textAlign: 'left',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 'none',
    },
}));

class Customers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 10,
            loading: true,
            customers: [],
            stats: {},
            anchorEl: null,
            selectedCustomer: null,
            startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0], // Last 30 days
            endDate: new Date().toISOString().split('T')[0],
            expandedCustomer: null,
        };
    }

    componentDidMount() {
        this.fetchCustomerData();
    }

    fetchCustomerData = async () => {
        this.setState({ loading: true });
        try {
            const form_data = new FormData();
            form_data.append('influencer_str', this.props.influencer_username);

            const response = await axios({
                method: 'post',
                url: paths.BACKEND_URL + "api/get_customer_data",
                data: form_data,
                headers: {
                    'Content-type': 'application/json',
                },
                withCredentials: true,
            });

            if (response.data.error) {
                this.setState({
                    loading: false,
                    error: response.data.error
                });
                return;
            }

            // Transform the customer data to match our component's structure
            const transformedCustomers = response.data.customers.map(customer => {
                const products = [];

                // Check each type of info and add as product if exists
                const infoTypes = {
                    member_info: '♻️ Membership',
                    old_member_info: '♻️ Expired Membership',
                    free_member_info: '🆓 Free Member',
                    courses_info: '📦 Course',
                    coaching_info: '🤝 Coaching',
                    old_coaching_info: '🤝 Expired Coaching',
                    digital_products_info: '📦 Digital Product',
                    tips_info: '💰 Tip',
                    messages_info: '💬 Messages',
                    waiting_list_info: '⏳ Waiting List'
                };

                Object.entries(infoTypes).forEach(([key, defaultLabel]) => {
                    if (customer[key] && Object.keys(customer[key]).length > 0) {
                        products.push({
                            ...customer[key],
                            product: customer[key].product || defaultLabel
                        });
                    }
                });

                return {
                    id: customer.username,
                    name: customer.display_name,
                    email: customer.email,
                    products: products
                };
            });

            this.setState({
                loading: false,
                customers: transformedCustomers,
                fee_rate: response.data.fee_rate
            });

        } catch (error) {
            console.error('Error fetching customer data:', error);
            this.setState({
                loading: false,
                error: 'Failed to load customer data'
            });
        }
    };

    getProductLabel = (status) => {
        switch (status) {
            case 'subscribed':
                return 'Subscription';
            case 'purchased_content':
                return 'Single Content';
            case 'cart_abandoned':
                return 'Cart Abandoned';
            case 'viewer':
                return 'Viewer';
            default:
                return 'Unknown';
        }
    };


    getStatusLabel = (status) => {
        switch (status) {
            case 'subscribed':
                return 'Active';
            case 'purchased_content':
                return 'Purchased';
            case 'cart_abandoned':
                return 'Abandoned';
            case 'viewer':
                return 'Viewer';
            default:
                return 'Unknown';
        }
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    handleMenuClick = (event, customer) => {
        this.setState({
            anchorEl: event.currentTarget,
            selectedCustomer: customer
        });
    };

    handleMenuClose = () => {
        this.setState({
            anchorEl: null,
            selectedCustomer: null
        });
    };

    handleExpandClick = (customerId) => {
        this.setState(prevState => ({
            expandedCustomer: prevState.expandedCustomer === customerId ? null : customerId
        }));
    };

    renderMobileCustomerRow = (customer) => {
        // Basic customer check
        if (!customer) return null;

        const isExpanded = this.state.expandedCustomer === customer.id;
        // Initialize products array safely
        const products = customer.products || [];

        return (
            <React.Fragment key={customer.id}>
                <StyledTableRow
                    onClick={() => this.handleExpandClick(customer.id)}
                    sx={{ cursor: 'pointer' }}
                >
                    <StyledTableCell>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <div>
                                <div style={{ fontWeight: '600' }}>{customer.name || 'Unknown'}</div>
                                <div style={{ color: '#6E89AF', fontSize: '13px' }}>{customer.email || 'No email'}</div>
                            </div>
                            {isExpanded ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                        </Box>
                    </StyledTableCell>
                </StyledTableRow>
                {isExpanded && (
                    <StyledTableRow>
                        <StyledTableCell>
                            {products.length === 0 ? (
                                <Box sx={{ fontSize: '13px', padding: '10px 0' }}>
                                    <div style={{ color: '#6E89AF' }}>No product information available</div>
                                </Box>
                            ) : (
                                products.map((product, index) => (
                                    <Box key={index} sx={{
                                        fontSize: '13px',
                                        borderBottom: index < products.length - 1 ? '1px solid #E4EBF6' : 'none',
                                        padding: '10px 0'
                                    }}>
                                        <div style={{ marginBottom: '8px' }}>
                                            <span style={{ color: '#6E89AF' }}>Product: </span>
                                            {product.product || 'No product'}
                                        </div>
                                        <div style={{ marginBottom: '8px' }}>
                                            <span style={{ color: '#6E89AF' }}>Price: </span>
                                            {product.currency === 'gbp' ? '£' : product.currency === 'usd' ? '$' : product.currency === 'eur' ? '€' : product.currency === 'sek' ? 'kr' : product.currency === 'aud' ? 'AU$' : product.currency === 'cad' ? 'CA$' : product.currency === 'nzd' ? 'NZ$' : ''}
                                            {product.price ? CreatePriceStr(product.price, '', false) : 'Free'}                                        </div>
                                        <div style={{ marginBottom: '8px' }}>
                                            <span style={{ color: '#6E89AF' }}>Date: </span>
                                            {product.date || '-'}
                                        </div>
                                        <div>
                                            <span style={{ color: '#6E89AF' }}>Status: </span>
                                            <span style={{
                                                backgroundColor: product.status === 'Active' ? '#EDEFFE' : '#FFF5F5',
                                                color: product.status === 'Active' ? 'var(--brand-color)' : 'var(--warning-color)',
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                            }}>
                                                {product.status || 'Unknown'}
                                            </span>
                                        </div>
                                    </Box>
                                ))
                            )}
                        </StyledTableCell>
                    </StyledTableRow>
                )}
            </React.Fragment>
        );
    };

    renderDesktopCustomerRow = (customer) => {
        // Basic customer check
        if (!customer) return null;

        // Initialize products array safely
        const products = customer.products || [];
        const hasMultipleProducts = products.length > 1;
        const isExpanded = this.state.expandedCustomer === customer.id;

        // Single product or no products case
        if (!hasMultipleProducts) {
            const product = products[0] || {
                product: 'No product',
                price: null,
                date: '-',
                status: 'Unknown'
            };

            return (
                <StyledTableRow key={customer.id}>
                    <StyledTableCell sx={{ width: '25%' }}>
                        <div>
                            <div style={{ fontWeight: '600' }}>{customer.name || 'Unknown'}</div>
                            <div style={{ color: '#6E89AF', fontSize: '13px' }}>{customer.email || 'No email'}</div>
                        </div>
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '25%' }}>{product.product}</StyledTableCell>
                    <StyledTableCell sx={{ width: '15%' }}>
                        {product.currency === 'gbp' ? '£' : product.currency === 'usd' ? '$' : product.currency === 'eur' ? '€' : product.currency === 'sek' ? 'kr' : product.currency === 'aud' ? 'AU$' : product.currency === 'cad' ? 'CA$' : product.currency === 'nzd' ? 'NZ$' : ''}
                        {product.price ? CreatePriceStr(product.price, '', false) : 'Free'}
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '15%' }}>{product.date}</StyledTableCell>
                    <StyledTableCell sx={{ width: '20%' }}>
                        <span style={{
                            backgroundColor: product.status === 'Active' ? '#EDEFFE' : '#FFF5F5',
                            color: product.status === 'Active' ? 'var(--brand-color)' : 'var(--warning-color)',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: '600'
                        }}>
                            {product.status}
                        </span>
                    </StyledTableCell>
                </StyledTableRow>
            );
        }

        return (
            <React.Fragment key={customer.id}>
                <StyledTableRow
                    onClick={() => this.handleExpandClick(customer.id)}
                    sx={{ cursor: 'pointer' }}
                >
                    <StyledTableCell sx={{ width: '25%' }}>
                        <div>
                            <div style={{ fontWeight: '600' }}>{customer.name}</div>
                            <div style={{ color: '#6E89AF', fontSize: '13px' }}>{customer.email}</div>
                        </div>
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '25%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {customer.products[0].product}
                            {isExpanded ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                        </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '15%' }}>
                        {customer.products[0].price ? CreatePriceStr(customer.products[0].price, (customer.products[0].currency || 'gbp').toUpperCase(), false) : 'Free'}
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '15%' }}>{customer.products[0].date}</StyledTableCell>
                    <StyledTableCell sx={{ width: '20%' }}>
                        <span style={{
                            backgroundColor: customer.products[0].status === 'Active' ? '#EDEFFE' : '#FFF5F5',
                            color: customer.products[0].status === 'Active' ? 'var(--brand-color)' : 'var(--warning-color)',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: '600'
                        }}>
                            {customer.products[0].status}
                        </span>
                    </StyledTableCell>
                </StyledTableRow>
                {isExpanded && customer.products.slice(1).map((product, index) => (
                    <StyledTableRow key={`${customer.id}-${index + 1}`} sx={{ backgroundColor: 'var(--rebranding-content-background-color) !important' }}>
                        <StyledTableCell sx={{ width: '25%', padding: '16px' }} />
                        <StyledTableCell sx={{ width: '25%', padding: '16px' }}>{product.product}</StyledTableCell>
                        <StyledTableCell sx={{ width: '15%', padding: '16px' }}>
                            {product.price ? CreatePriceStr(product.price, '', false) : 'Free'}
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: '15%', padding: '16px' }}>{product.date}</StyledTableCell>
                        <StyledTableCell sx={{ width: '20%', padding: '16px' }}>
                            <span style={{
                                backgroundColor: product.status === 'Active' ? '#EDEFFE' : '#FFF5F5',
                                color: product.status === 'Active' ? 'var(--brand-color)' : 'var(--warning-color)',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                fontWeight: '600'
                            }}>
                                {product.status}
                            </span>
                        </StyledTableCell>
                    </StyledTableRow>
                ))}
            </React.Fragment>
        );
    };

    render() {
        const { page, rowsPerPage, loading, customers, anchorEl, error } = this.state;

        if (error) {
            return (
                <div>
                    <Typography style={{ color: '#222222', fontSize: '26px', fontWeight: '600', marginBottom: '20px' }}>
                        Customers
                    </Typography>
                    <Box sx={{ p: 3, textAlign: 'center' }}>
                        <Typography color="error">{error}</Typography>
                    </Box>
                </div>
            );
        }

        return (
            <div>

                {loading ? (
                    <PageSkeletonCustomers />
                ) : (
                    <div style={{
                        backgroundColor: '#fff',
                        border: '1px solid #E4EBF6',
                        borderRadius: '8px',
                        padding: '0px'
                    }}>
                        {customers && customers.length > 0 ? (
                            <>
                                <TableContainer>
                                    {/* Desktop view */}
                                    <Table sx={{ minWidth: 650, display: { xs: 'none', sm: 'table' } }} size="medium">
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell sx={{ width: '25%' }}>Name</StyledTableCell>
                                                <StyledTableCell sx={{ width: '25%' }}>Product</StyledTableCell>
                                                <StyledTableCell sx={{ width: '15%' }}>Price</StyledTableCell>
                                                <StyledTableCell sx={{ width: '15%' }}>Date</StyledTableCell>
                                                <StyledTableCell sx={{ width: '20%' }}>Status</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {customers
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map(this.renderDesktopCustomerRow)}
                                        </TableBody>
                                    </Table>

                                    {/* Mobile view */}
                                    <Table sx={{ display: { xs: 'table', sm: 'none' } }} size="medium">
                                        <TableBody>
                                            {customers
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map(this.renderMobileCustomerRow)}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    component="div"
                                    count={customers.length}
                                    page={page}
                                    onPageChange={this.handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    rowsPerPageOptions={[5, 10, 25]}
                                />

                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={this.handleMenuClose}
                                >
                                    <MenuItem onClick={this.handleMenuClose}>View Details</MenuItem>
                                    <MenuItem onClick={this.handleMenuClose}>Contact Customer</MenuItem>
                                    <MenuItem onClick={this.handleMenuClose}>View Purchase History</MenuItem>
                                </Menu>
                            </>
                        ) : (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: { xs: '0', sm: '40px 0' },
                                    textAlign: "center",
                                }}
                            >
                                <div style={{ 
                                    padding: '24px 16px', 
                                    textAlign: 'center', 
                                    borderRadius: '8px',
                                }}>
                                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>😔</div>
                                    <h3 style={{
                                        margin: '0',
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        color: '#1D1D1D',
                                        fontFamily: 'Roboto, sans-serif',
                                        marginBottom: '8px'
                                    }}>No Customers Yet</h3>
                                    <p style={{
                                        fontSize: '14px',
                                        color: '#6E7787',
                                        fontWeight: '400',
                                        textAlign: 'center',
                                        margin: '0 auto 24px',
                                        maxWidth: '400px',
                                        fontFamily: 'Roboto, sans-serif'
                                    }}>
                                        You'll see your customers here once you make your first sale.
                                    </p>
                                    <div style={{
                                        backgroundColor: '#F5F8FF',
                                        padding: '16px',
                                        margin: '0 auto 24px',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                        color: '#3B55F3',
                                        border: '1px solid #E4EBF6',
                                        maxWidth: '400px',
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px'
                                        }}>
                                            <AiOutlineSafety style={{ fontSize: '20px' }} />
                                            <span style={{
                                                fontSize: '16px',
                                                fontWeight: '600'
                                            }}>Focus on What You Love</span>
                                        </div>
                                        <p style={{
                                            fontSize: '14px',
                                            margin: '0',
                                            fontWeight: '400',
                                            lineHeight: '20px',
                                            textAlign: 'center'
                                        }}>
                                            WithMe handles all refunds and chargebacks automatically. No need to worry about payment disputes – just focus on creating amazing content for your audience.
                                        </p>
                                    </div>
                                    <p style={{
                                        fontSize: '14px',
                                        color: '#6E7787',
                                        fontWeight: '400',
                                        textAlign: 'center',
                                        margin: '0',
                                        fontFamily: 'Roboto, sans-serif'
                                    }}>
                                        Learn more about<a href={'https://help.withme.so/en/collections/8546931-growing-your-audience'} target="_blank" style={{ color: '#3B55F3', textDecoration: 'none' }}> how to get customers here.</a>
                                    </p>
                                </div>
                            </Box>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default Customers;
